;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();export default function Clipboard() {
  return (
    <svg width="146" height="124" viewBox="0 0 146 124" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M73.0004 32.7696C65.9359 32.7696 60.6582 26.861 60.6582 19.5843V15.1853C60.6582 7.90866 65.9359 2 73.0004 2C80.0648 2 85.3426 7.90866 85.3426 15.1853V19.5843C85.3426 26.861 80.0648 32.7696 73.0004 32.7696Z"
        stroke="#64358C"
        strokeWidth="3"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M51.381 48.1602V45.0821C51.381 36.6496 65.297 32.7812 72.9887 32.7812C80.6804 32.7812 94.5963 36.5788 94.5963 45.0112V48.1602"
        stroke="#64358C"
        strokeWidth="3"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M29.7729 51.2383C22.7084 51.2383 17.4307 45.3297 17.4307 38.0531V33.6541C17.4307 26.3774 22.7084 20.4688 29.7729 20.4688C36.8374 20.4688 42.115 26.3774 42.115 33.6541V38.0531C42.115 45.3297 36.8374 51.2383 29.7729 51.2383Z"
        stroke="#64358C"
        strokeWidth="3"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M8.16534 66.6172V63.5391C8.16534 55.1067 22.0813 51.2383 29.773 51.2383C37.4647 51.2383 51.3807 55.0358 51.3807 63.4683V66.6172"
        stroke="#64358C"
        strokeWidth="3"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M116.215 51.2383C109.151 51.2383 103.873 45.3297 103.873 38.0531V33.6541C103.873 26.3774 109.151 20.4688 116.215 20.4688C123.28 20.4688 128.557 26.3774 128.557 33.6541V38.0531C128.557 45.3297 123.28 51.2383 116.215 51.2383Z"
        stroke="#64358C"
        strokeWidth="3"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M94.6071 66.6172V63.5391C94.6071 55.1067 108.523 51.2383 116.215 51.2383C123.906 51.2383 137.822 55.0358 137.822 63.4683V66.6172"
        stroke="#64358C"
        strokeWidth="3"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M73.0706 58.0552L83.6141 80.0739L106.949 82.4797L90.1342 99.9815L94.0037 122L73.0706 112.282L52.1256 122L55.995 99.9815L39.1918 82.4797L62.5152 80.0739L73.0706 58.0552Z"
        stroke="#E2001A"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M39.2868 97.1038L42.1269 112.766L26.7908 105.855L11.4667 112.766L14.3067 97.1038L2 84.6617L19.0756 82.9515L26.7908 67.2896L30.7314 75.2739"
        stroke="#64358C"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M106.701 97.1038L103.861 112.766L119.197 105.855L134.522 112.766L131.693 97.1038L144 84.6617L126.913 82.9515L119.197 67.2896L115.257 75.2739"
        stroke="#64358C"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
